import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../common/store/generic.effects';
import { GroupAction, groupActions } from './group.actions';
import { GroupApiService } from './group.api.service';

@Injectable()
export class GroupEffects {
  constructor(
    private readonly groupApiService: GroupApiService,
    private readonly action$: Actions<GroupAction>,
  ) {}

  getListItem = createApiCallEffects(
    this,
    this.action$,
    groupActions.getListItem,
    this.groupApiService.getListItem,
  );
}
